import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { isFaireDirectVariant } from "@faire/retailer-visitor-shared/components/AppSignUp/AppSignUpModalVariant";
import { useEmailState } from "@faire/retailer-visitor-shared/components/AppSignUp/state/useEmailState";
import { useHandleModalState } from "@faire/retailer-visitor-shared/components/AppSignUp/state/useHandleModalState";
import { useStoreOpeningDateState } from "@faire/retailer-visitor-shared/components/AppSignUp/state/useStoreOpeningDateState";
import { useTrackEmailEntryAndSubmit } from "@faire/retailer-visitor-shared/components/AppSignUp/state/useTrackEmailEntryAndSubmit";
import { buildFaireDirectParams } from "@faire/retailer-visitor-shared/components/AppSignUp/utils/paramBuilders";
import { useFaireDirectBrand } from "@faire/retailer-visitor-shared/hooks/FaireDirect/useFaireDirectBrand/useFaireDirectBrand";
import { showSSOButtons } from "@faire/retailer-visitor-shared/lib/ssoUtils";
import { useSSOProviderOptionsStore } from "@faire/retailer-visitor-shared/stores/domain/SSO/useSSOProviderOptionsStore";
import { useSSOStore } from "@faire/retailer-visitor-shared/stores/domain/SSO/useSSOStore";
import { pathMatchesRoute } from "@faire/web--source/common/routes/RouteMatcher";
import { trackEvent } from "@faire/web--source/common/trackEvent";
import { useQueryParams } from "@faire/web--source/ui/hooks/useQueryParams";
import { removeLocaleFromUrl } from "@faire/web--source/ui/routing/util";
import userLoginData from "@faire/web-api--source/api/user/login-data/post";
import saveIncompleteSignupAttempt from "@faire/web-api--source/api/user/retailer-signup-attempt/post";
import { trackSignupReportExistingEmail } from "@faire/web-api--source/events/signup/actionUnknown/reportExistingEmail";
import { trackSignupReportExistingSso } from "@faire/web-api--source/events/signup/actionUnknown/reportExistingSso";
import { ILoginDataRequest } from "@faire/web-api--source/indigofair/data/ILoginDataRequest";
import { ISignUpRequest } from "@faire/web-api--source/indigofair/data/ISignUpRequest";
import { IUser } from "@faire/web-api--source/indigofair/data/IUser";
import { SocialSignOnProvider } from "@faire/web-api--source/indigofair/data/SocialSignOnProvider";
import { route as openWithFaireRoute } from "@faire/web-api--source/routes/www/open-with-faire";
import { route as videoPageRoute } from "@faire/web-api--source/routes/www/video/videoToken";
import signUpPersonal, { QueryParameters as SignUpQueryParameters } from "@faire/web-api--source/routes/www/welcome/r/personal";
import qs from "qs";
import { useCallback, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { useHistory } from "react-router-dom";
export var useAppSignUpState = function() {
    var location = useLocation();
    var history = useHistory();
    var setProviders = useSSOProviderOptionsStore().setProviders;
    var setPromptSSO = useSSOStore().setPromptSSO;
    var _useFaireDirectBrand = useFaireDirectBrand(), faireDirectBrand = _useFaireDirectBrand.faireDirectBrand, faireDirectBrandToken = _useFaireDirectBrand.faireDirectBrandToken, faireDirectBrandAlias = _useFaireDirectBrand.faireDirectBrandAlias;
    var _useTrackEmailEntryAndSubmit = useTrackEmailEntryAndSubmit(), markUserEntersEmail = _useTrackEmailEntryAndSubmit.markUserEntersEmail, trackTimeBetweenEmailEntryAndSubmit = _useTrackEmailEntryAndSubmit.trackTimeBetweenEmailEntryAndSubmit;
    var signUpParams = useQueryParams(SignUpQueryParameters.parse);
    var _useHandleModalState = useHandleModalState(), modalVariant = _useHandleModalState.modalVariant, handleModalClose = _useHandleModalState.handleModalClose, recordModalSignUpActivity = _useHandleModalState.recordModalSignUpActivity;
    var isFaireDirectSignup = isFaireDirectVariant(modalVariant);
    var _useEmailState = useEmailState(isFaireDirectSignup), email = _useEmailState.email, getIsEmailAvailable = _useEmailState.getIsEmailAvailable, setEmailValidationErrors = _useEmailState.setEmailValidationErrors, setSomethingWentWrongEmailError = _useEmailState.setSomethingWentWrongEmailError;
    var storeOpeningDate = useStoreOpeningDateState().storeOpeningDate;
    var isOpenWithFaireSignUp = useMemo(function() {
        return pathMatchesRoute(location, openWithFaireRoute);
    }, [
        location
    ]);
    var dismissible = useMemo(function() {
        return !signUpParams.livestream && !pathMatchesRoute(location, videoPageRoute);
    }, [
        location,
        signUpParams.livestream
    ]);
    var saveIncompleteSignup = useCallback(/*#__PURE__*/ _async_to_generator(function() {
        var payload, error;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    payload = ISignUpRequest.build({
                        user: IUser.build({
                            email_address: email.value
                        })
                    });
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        saveIncompleteSignupAttempt(payload)
                    ];
                case 2:
                    _state.sent();
                    return [
                        3,
                        4
                    ];
                case 3:
                    error = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    }), [
        email.value
    ]);
    var signupWithAvailableEmail = useCallback(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(queryParamsOverride) {
            var faireDirectParams, query, redirectLocation;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        faireDirectParams = buildFaireDirectParams(signUpParams, modalVariant, faireDirectBrandToken, faireDirectBrand === null || faireDirectBrand === void 0 ? void 0 : faireDirectBrand.name, faireDirectBrandAlias);
                        query = _object_spread(_object_spread_props(_object_spread({}, signUpParams), {
                            email: email.value.trim(),
                            source: removeLocaleFromUrl(location.pathname),
                            storeOpeningDate: storeOpeningDate.value && storeOpeningDate.value > 0 ? "".concat(storeOpeningDate.value) : undefined
                        }), faireDirectParams, queryParamsOverride);
                        redirectLocation = signUpPersonal(query);
                        trackEvent("sign-up-page/modal/submit-email/success");
                        recordModalSignUpActivity();
                        history.push(redirectLocation);
                        return [
                            4,
                            saveIncompleteSignup()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(queryParamsOverride) {
            return _ref.apply(this, arguments);
        };
    }(), [
        email.value,
        faireDirectBrand === null || faireDirectBrand === void 0 ? void 0 : faireDirectBrand.name,
        faireDirectBrandAlias,
        faireDirectBrandToken,
        history,
        location.pathname,
        modalVariant,
        recordModalSignUpActivity,
        saveIncompleteSignup,
        signUpParams,
        storeOpeningDate.value
    ]);
    var attemptSSOSignup = useCallback(/*#__PURE__*/ _async_to_generator(function() {
        var available_social_providers, _available_social_providers_length, _signUpParams_signUp;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        userLoginData(ILoginDataRequest.build({
                            email_address: email.value
                        }))
                    ];
                case 1:
                    available_social_providers = _state.sent().available_social_providers;
                    if (((_available_social_providers_length = available_social_providers === null || available_social_providers === void 0 ? void 0 : available_social_providers.length) !== null && _available_social_providers_length !== void 0 ? _available_social_providers_length : 0) > 0 && showSSOButtons()) {
                        setProviders(available_social_providers.map(function(provider) {
                            return SocialSignOnProvider[provider];
                        }));
                        setPromptSSO(true);
                        trackSignupReportExistingSso();
                    } else {
                        trackSignupReportExistingEmail();
                    }
                    trackEvent("sign-up-page/modal/submit-email/in-use");
                    history.replace(_object_spread_props(_object_spread({}, history.location), {
                        search: qs.stringify(_object_spread_props(_object_spread({}, signUpParams), {
                            signUp: undefined,
                            signIn: (_signUpParams_signUp = signUpParams.signUp) !== null && _signUpParams_signUp !== void 0 ? _signUpParams_signUp : "1",
                            email: email.value.trim()
                        }))
                    }));
                    return [
                        2
                    ];
            }
        });
    }), [
        email.value,
        history,
        signUpParams,
        setPromptSSO,
        setProviders
    ]);
    var handleSubmit = useCallback(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(e, queryParamsOverride) {
            var isEmailAvailable, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e === null || e === void 0 ? void 0 : e.preventDefault();
                        e === null || e === void 0 ? void 0 : e.stopPropagation();
                        trackEvent("sign-up-page/modal/submit-email/attempt");
                        trackTimeBetweenEmailEntryAndSubmit();
                        if (setEmailValidationErrors()) {
                            trackEvent("sign-up-page/modal/submit-email/invalid");
                            return [
                                2
                            ];
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            ,
                            8
                        ]);
                        return [
                            4,
                            getIsEmailAvailable()
                        ];
                    case 2:
                        isEmailAvailable = _state.sent();
                        if (!isEmailAvailable) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            signupWithAvailableEmail(queryParamsOverride)
                        ];
                    case 3:
                        _state.sent();
                        return [
                            3,
                            6
                        ];
                    case 4:
                        return [
                            4,
                            attemptSSOSignup()
                        ];
                    case 5:
                        _state.sent();
                        _state.label = 6;
                    case 6:
                        return [
                            3,
                            8
                        ];
                    case 7:
                        error = _state.sent();
                        setSomethingWentWrongEmailError(error);
                        return [
                            3,
                            8
                        ];
                    case 8:
                        return [
                            2
                        ];
                }
            });
        });
        return function(e, queryParamsOverride) {
            return _ref.apply(this, arguments);
        };
    }(), [
        trackTimeBetweenEmailEntryAndSubmit,
        setEmailValidationErrors,
        getIsEmailAvailable,
        signupWithAvailableEmail,
        attemptSSOSignup,
        setSomethingWentWrongEmailError
    ]);
    return {
        email: email,
        signUpParams: signUpParams,
        isOpenWithFaireSignUp: isOpenWithFaireSignUp,
        dismissible: dismissible,
        modalVariant: modalVariant,
        storeOpeningDate: storeOpeningDate,
        handleSubmit: handleSubmit,
        handleModalClose: handleModalClose,
        markUserEntersEmail: markUserEntersEmail,
        setEmailValidationErrors: setEmailValidationErrors
    };
};
